import React, { useState } from "react";
import {
  Card,
  Button,
  Rate,
  Modal,
  Carousel,
  Tag,
  Typography,
  Flex,
} from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import "tailwindcss/tailwind.css";
import { useNavigate } from "react-router-dom";
const { Text, Paragraph } = Typography;

const HolidayCard = ({ hotel }) => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleImageClick = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  const [rating, setRating] = useState(4.9);
  const [count, setCount] = useState(); // Optional: if this comes from a database
 const navigate = useNavigate();
  return (
    <Card  onClick={() => navigate('/cruise-detail')}  
    className="cursor-pointer shadow-[0px_0px_6px_rgba(0,0,0,0.25)] rounded-[4px] overflow-hidden p-0 hover:shadow-lg transition-all">
      <Flex className="gap-4">
        {/* Left Images Section */}
        <div className="w-[35%]">
          <div className="relative w-full">
            <img
              src={hotel.images[0]}
              alt="Main"
              className="w-full h-40 object-cover rounded-lg cursor-pointer"
              onClick={() => handleImageClick(0)}
            />
            <Tag
              color="red"
              className="absolute top-2 left-2 text-white font-semibold"
            >
              {hotel.duration}
            </Tag>
          </div>

          {/* Thumbnails */}
          <div className="flex mt-2 gap-2">
            {hotel.images.slice(1, 4).map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`thumb-${index}`}
                className="w-[32%]  h-16  object-cover rounded-md cursor-pointer hover:opacity-80"
                onClick={() => handleImageClick(index + 1)}
              />
            ))}
          </div>
        </div>

        {/* Center Content */}
        <div className="w-[45%] flex flex-col justify-between">
          <div>
            <h3 className="text-lg font-medium leading-6">{hotel.title}</h3>
            {/* <p className="text-sm mb-3">{hotel.subtitle}</p> */}

            <ul className="grid grid-cols-2 text-sm gap-y-1 my-3">
              {hotel.features.map((f, i) => (
                <li className="font-medium text-xs text-black/40" key={i}>
                  • {f}
                </li>
              ))}
            </ul>

            <div className="mt-2 text-xs">
              <Paragraph className="!mb-1 text-xs font-semibold">
                Hotel Options:{" "}
              </Paragraph>
              <Paragraph className="text-[#008234] font-medium text-xs">
                {hotel.hotelOptions}
              </Paragraph>
              <Paragraph className="!mb-1 text-xs font-semibold">
                {" "}
                Tour Options:
              </Paragraph>

              <Paragraph className="!mb-0 text-xs font-medium text-black/40">
                {" "}
                {hotel.tourOptions}
              </Paragraph>
            </div>
          </div>
        </div>
        <div className="relative">
          {/* vertical line */}
          <div className="absolute left-0 top-0 bottom-0 w-[1px] bg-gray-200 h-[100%]"></div>
        </div>
        {/* Right Pricing */}
        <div className="w-[20%] flex flex-col justify-between">
          <div>
            <div className="flex items-center space-x-2">
              <Rate
                allowHalf
                defaultValue={rating}
                onChange={(value) => setRating(value)}
                className="text-primary no-star-gap"
              />
              <span className="text-sm text-gray-700">
                {rating.toFixed(1)}{" "}
                <span className="text-gray-500">({hotel.reviews})</span>
              </span>
            </div>
          </div>

          <div className="text">
            <p className="line-through text-black/40 text-sm">
              INR {hotel.oldPrice}
            </p>
            <p className="text-2xl font-bold text-gray-800">
              INR {hotel.price}
            </p>
            <p className="text-sm font-medium text-black/40">
              + ₹{hotel.taxes} taxes & fees Per night
            </p>
          </div>

          <Button
            type="danger"
            size="middle"
            className="font-medium px-12 py-5 text-sm rounded-tl-[12px] 
                     rounded-bl-none rounded-tr-none rounded-br-[12px] bg-danger hover:bg-red-700 border-none rounded-md text-white"
          >
            Book Now
          </Button>
        </div>
      </Flex>

      {/* Image Slider Modal */}
      <Modal
        open={open}
        footer={null}
        onCancel={() => setOpen(false)}
        width={800}
        centered
      >
        <Carousel initialSlide={currentIndex} arrows>
          {hotel.images.map((img, i) => (
            <div key={i}>
              <img
                src={img}
                alt={`slide-${i}`}
                className="w-full h-[400px] object-cover rounded-lg"
              />
            </div>
          ))}
        </Carousel>
      </Modal>
    </Card>
  );
};

export default HolidayCard;
